/**
 * Boilerplate.js
 */

import $ from 'jquery';

export default class Collapse {

    constructor() {

        if (!$('[data-toggle="collapse"]').length) {
            return;
        }
        this.collapses = $('[data-toggle="collapse"]');
        this.collapses.on('click', this.toggle);

    }

    toggle() {
        let target = $(this).data('target');
        $(target).attr('aria-expanded','false') ? $(target).attr('aria-expanded','true') : $(target).attr('aria-expanded','false');;
        $(target).hasClass('show') ? $(target).removeClass('show') : $(target).addClass('show');
    }

}
